// extracted by mini-css-extract-plugin
module.exports = {"container":"Markadsefni-module--container--1D8Md","card_container":"Markadsefni-module--card_container--2ZNZ4"};